import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Datepicker = _resolveComponent("Datepicker");
    return (_openBlock(), _createBlock(_component_Datepicker, {
        "model-value": _ctx.value,
        "start-date": _ctx.startDate,
        range: _ctx.range,
        "max-range": _ctx.maxRange,
        "min-date": _ctx.minDate,
        "max-date": _ctx.maxDate,
        "enable-time-picker": _ctx.timePicker,
        format: "dd/MM/yyyy - HH:mm",
        "onUpdate:modelValue": _ctx.handleUpdate
    }, null, 8, ["model-value", "start-date", "range", "max-range", "min-date", "max-date", "enable-time-picker", "onUpdate:modelValue"]));
}
